import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';
// import PdfReport from 'modules/Programs/Lesson/LessonSection/PdfReport';
// import store from 'store';

import { useServiceRouter } from '@common/components/ServiceRouter';
import Tabs from '@common/components/Tabs';
import { getRoute } from '@common/constants/CampusRoutes';
// import ConsultationPackagesEnum from '@common/constants/Consultations';
import gradebookStatusId from '@common/constants/gradebookStatusId';
import useId from '@common/helpers/useId';
import { IChunksModel } from '@common/models/Chunks/Chunks';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

import LessonDescriptionDetails from './Details';
import LessonDescriptionTeacherComment from './TeacherComment';
import { StyledLessonDescriptionHeaderWrap, StyledLessonDescriptionNextLesson } from './styled';

interface PropsType {
	lessonModel: IStudentLessonModel;
	chunksModel: IChunksModel;
}

function LessonSectionDescription({ lessonModel, chunksModel }: PropsType) {
	const { t } = useTranslation();
	const { programId, groupId, programGroupId } = useId(['programId', 'groupId', 'programGroupId']);
	const { checkService } = useServiceRouter();
	const isTalented = checkService('talented');
	// const isSelfPaced =
	// 	store.profile?.consultation?.package_id === ConsultationPackagesEnum.SELF_PACED;

	const navigate = useNavigate();

	const canShowTeacherFeedback =
		lessonModel.gradebook?.is_done === gradebookStatusId.done ||
		lessonModel.gradebook?.is_done === gradebookStatusId.reject;

	const handleGoNextLesson = () => {
		navigate(
			getRoute(
				['PROGRAMS'],
				programId,
				groupId,
				programGroupId,
				lessonModel.next_schedule_lesson?.id,
			),
		);
	};

	// Nav(64px) + padding(24px top + bottom)
	const topPosition = '112px';

	return (
		<>
			<StyledLessonDescriptionHeaderWrap>
				<Typography variant="subtitle1">{t('lesson.discoverYourself')}</Typography>
			</StyledLessonDescriptionHeaderWrap>
			<Box marginInline="8px" sx={{ position: 'sticky', top: topPosition }}>
				<Tabs
					tabs={[
						{
							label: t('tabs.details'),
							element: (
								<LessonDescriptionDetails lessonModel={lessonModel} chunksModel={chunksModel} />
							),
						},
						...(canShowTeacherFeedback
							? [
									{
										label: t('tabs.teacherComment'),
										element: <LessonDescriptionTeacherComment lessonModel={lessonModel} />,
									},
								]
							: []),
						// ...(isTalented && !isSelfPaced
						// 	? [
						// 			{
						// 				label: t('tabs.pdfReport'),
						// 				element: <PdfReport lessonModel={lessonModel} />,
						// 				...(lessonModel.gradebook.is_done === 2 ? { badge: 1 } : {}),
						// 			},
						// 		]
						// 	: []),
					]}
					variant="scrollable"
					sx={{
						display: 'flex',
						alignItems: 'center',
						'& .MuiTabScrollButton-root': { width: 'auto' },
					}}
				/>
				<StyledLessonDescriptionNextLesson isTalented={isTalented}>
					{lessonModel.next_schedule_lesson?.id && !isTalented && (
						<Button
							variant="contained"
							color="primary"
							onClick={handleGoNextLesson}
							sx={{
								fontSize: '13px',
								padding: '10px 16px',
								height: 'auto',
							}}
						>
							{t('lesson.nextLesson')}
						</Button>
					)}
				</StyledLessonDescriptionNextLesson>
			</Box>
		</>
	);
}

export default LessonSectionDescription;
